import ControlledSelectForm from "../../common/ControlledSelectForm";
import ControlledSelectFormChangeDay from "../../common/ControlledSelectFormWithChangeDay";
import ControlledInput from "../../common/InputWithUpdatingState";
import TextEditor from "../../common/wysywyg";
import DefineList from "../DefineList/DefineList";
import Spinner from "../spinner/Spinner";

const optionsInclude = [
  { title: "ناهار" },
  { title: "شام" },
  { title: "صبحانه" },
  { title: "عصرانه" },
  { title: "گشت شهری" },
];
const UpdateTourFormThirdStep = ({
  formik,
  Dayoptions,
  includedPlanList,
  notIncludedPlanList,
  includedPlanListHandler,
  includedPlanListRemoveHandler,
  notIncludedPlanListListHandler,
  notIncludedPlanListRemoveHandler,
  chnageTourHandler,
  changedInput,
  descriptionValue,
  nextStepFlag,
  prevStepTab,
}) => {
  const goNextStep = () => {
    nextStepFlag(true);
  };
  const goPrevStep = () => {
    prevStepTab();
  };
  return (
    <>
      <div className="flex w-1/2 md:w-1/3 px-3 text-sm">
        <ControlledSelectFormChangeDay
          formik={formik}
          name="DayNumber"
          label="روز"
          options={Dayoptions}
          changedInput={changedInput}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={false}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <ControlledInput
          formik={formik}
          name="Title"
          label="عنوان"
          type="text"
          chnageTourHandler={chnageTourHandler}
          reqiuerd={false}
        />
      </div>
      <div className="flex w-full px-3 mb-5">
        <TextEditor
          label="توضیحات"
          formik={formik}
          name="Plan"
          chnageTourHandler={chnageTourHandler}
          descriptionValue={descriptionValue}
          reqiuerd={false}
        />
      </div>
      <div className="flex w-full md:w-1/3 px-3">
        <DefineList
          name="Included"
          label="شامل می‌باشد"
          formik={formik}
          list={includedPlanList}
          setList={includedPlanListHandler}
          removeList={includedPlanListRemoveHandler}
          suggested={optionsInclude}
          reqiuerd={false}
        />
      </div>
      <div className="flex w-full md:w-1/3 px-3">
        <DefineList
          name="NotIncluded"
          label="شامل نمی‌باشد"
          formik={formik}
          list={notIncludedPlanList}
          setList={notIncludedPlanListListHandler}
          removeList={notIncludedPlanListRemoveHandler}
          suggested={optionsInclude}
          reqiuerd={false}
        />
      </div>
      <div className="w-full flex justify-between px-3 mt-2">
        <div className="flex w-1/2 mt-2">
          <button
            onClick={goPrevStep}
            className="block w-auto mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-red-400 text-white text-center rounded-md py-2 px-4"
          >
            مرحله قبل
          </button>
        </div>
        <div className="flex w-1/2 justify-end gap-2">
          <button
            type="submit"
            //disabled={!formik.isValid}
            className="block w-24 mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
          >
            {formik.isSubmitting ? <Spinner /> : "ذخیره"}
          </button>
          <button
            type="submit"
            onClick={goNextStep}
            //disabled={!formik.isValid}
            className="block w-30 mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
          >
            {formik.isSubmitting ? <Spinner /> : "ذخیره و ادامه"}
          </button>
        </div>
      </div>
    </>
  );
};

export default UpdateTourFormThirdStep;
